<template>
  <div id="Disaster_apply">
    <div class="font">
      <span class="introSubTitle"><b>自然灾害遥感监测评估系统</b></span>
      <p class="textStyle">联合国家减灾中心研制了我国首套业务化运行的遥感自然灾害监测评估系统，部分核心指标优于国际主流系统,实现了我国自然灾害遥感应急监测评估从理论研究到业务实战的跨越（获2017年测绘科技进步一等奖，2012年国家科技进步二等奖）
</p>
    </div>

    <div style="text-align: center">
      <!-- <br/> -->
      <!-- <img width="100%" src="@/assets/img/scientific/Disaster_apply-1.gif" /> -->
      <!-- <br/>   -->
      <img width="100%" src="@/assets/img/scientific/Disaster_apply-3.jpg" />

      <!-- <img height="100%" src="@/assets/img/scientific/Disaster_apply-2.jpg" /> -->
    </div>
  </div>
</template>

<script>
// import myVideo from "../../node_modules/vue-video";

export default {
  data() {
    return {

    };
  },
};
</script>

<style lang="less">
#Disaster_apply {
  margin-top: 20px;
  .img_figure{
    display: flex;
    justify-content: center;
  }
}
</style>
